import React from 'react'
import { Block } from '@comp/crRender'
import SectionCard from '../../shared/SectionCard'
import TagList from '../../shared/TagList'
import './style.css'

const Specialties = ({ serviceCategories }) => {
    return (
        <Block isRender={serviceCategories?.length > 0}>
            <SectionCard icon="mdi:stethoscope" titleKey="service-categories">
                <TagList items={serviceCategories} />
            </SectionCard>
        </Block>
    )
}

export default Specialties

